import { Modal } from "antd";
import PassengerForm from "./PassengerForm";

/**
 * PassengerModal - Modal wrapper for PassengerForm
 *
 * @param {Object} props
 * @param {boolean} props.open - Whether the modal is open
 * @param {function} props.onClose - Callback to close the modal
 * @param {string} props.passengerId - Passenger ID to edit
 * @param {function} props.onSuccess - Optional callback when passenger is saved successfully
 */
function PassengerModal({ open, onClose, passengerId, onSuccess }) {
  const handleSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width="80vw"
      title="Editar Pasajero"
      styles={{ body: { maxHeight: "80vh", overflowY: "auto", overflowX: "hidden" } }}
      destroyOnClose
      centered
    >
      {open && (
        <PassengerForm
          passengerId={passengerId}
          onSuccess={handleSuccess}
          isModal={true}
        />
      )}
    </Modal>
  );
}

export default PassengerModal;
